/**
 * Photos are shrunk on the phone before upload: longest side at most 1600 px,
 * JPEG quality 0.8 (typically 200 to 400 kB instead of several MB).
 */
export const PHOTO_MAX_SIDE = 1600;

export interface ShrunkPhoto {
  blob: Blob;
  width: number;
  height: number;
}

export async function shrinkPhoto(file: Blob, maxSide = PHOTO_MAX_SIDE, quality = 0.8): Promise<ShrunkPhoto> {
  // createImageBitmap applies the camera's rotation (EXIF) in current browsers.
  const bitmap = await createImageBitmap(file, { imageOrientation: "from-image" });
  const scale = Math.min(1, maxSide / Math.max(bitmap.width, bitmap.height));
  const width = Math.round(bitmap.width * scale);
  const height = Math.round(bitmap.height * scale);
  const canvas = document.createElement("canvas");
  canvas.width = width;
  canvas.height = height;
  canvas.getContext("2d")!.drawImage(bitmap, 0, 0, width, height);
  bitmap.close?.();
  const blob = await new Promise<Blob>((resolve, reject) =>
    canvas.toBlob((b) => (b ? resolve(b) : reject(new Error("PHOTO_FAILED"))), "image/jpeg", quality),
  );
  return { blob, width, height };
}
